const ANSWERPACKS_UPDATED = (state, answerPacks) => { state.answerPacks = answerPacks }
const ERROR_UPDATED = (state, error) => { state.error = error }
const LOADING_UPDATED = (state, loading) => { state.loading = loading }
const QUESTIONS_UPDATED = (state, questions) => { state.questions = questions }
const SURVEY_UPDATED = (state, survey) => { state.survey = survey }
const SURVEY_KEY_UPDATED = (state, key) => { state.surveyKey = key }
const AVERAGEVOTECOUNT_UPDATED = (state, averageVotesCount) => { state.averageVotesCount = averageVotesCount }
const TOTALVOTECOUNT_UPDATED = (state, totalVotesCount) => { state.totalVotesCount = totalVotesCount }
const USER_VOTES_UPDATED = (state, userVotes) => { state.userVotes = userVotes }

const DURATION_UPDATED = (state, timeInSeconds) => {
  state.duration = parseInt(timeInSeconds)
  try {
    localStorage[`iDalgoSurvey-${state.survey.id}-duration`] = timeInSeconds
  } catch (e) {}
}

export default {
  ANSWERPACKS_UPDATED,
  ERROR_UPDATED,
  LOADING_UPDATED,
  QUESTIONS_UPDATED,
  SURVEY_UPDATED,
  SURVEY_KEY_UPDATED,
  AVERAGEVOTECOUNT_UPDATED,
  TOTALVOTECOUNT_UPDATED,
  USER_VOTES_UPDATED,
  DURATION_UPDATED
}
